// extracted by mini-css-extract-plugin
module.exports = {"fullTitle":"werB4G-Bt2njbFQbQ7s5iQ=="};